export const PAYMENT_STATUS_SUCCEEDED = "succeeded";
export const PAYMENT_STATUS_FAILED = "failed";
export const PAYMENT_STATUS_PROCESSING = "processing";

export const PAYMENT_STATUS_LABELS = {
  [PAYMENT_STATUS_SUCCEEDED]: "Paid",
  [PAYMENT_STATUS_FAILED]: "Payment failed",
  [PAYMENT_STATUS_PROCESSING]: "Processing",
};

export const PAYMENT_STATUS_UNKNOWN_LABEL = "Unknown";
